var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vv-login"},[_c('el-container',[_c('el-main',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"vv-login-form"},[_c('div',{staticClass:"vv-logo"},[_vm._v("学生公交扫码系统")]),_c('login-form')],1)])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }